module.exports = __webpack_public_path__ + "img/cs-round-pipes-cards.0b167bdd.jpg";